import React from 'react';
import { Box, Typography } from '@mui/material';

interface PageHeaderProps {
  title: React.ReactNode;
  /** Muted descriptive line under the title. rillo shows inline stats here. */
  subtitle?: React.ReactNode;
  /** Right-aligned actions (buttons, toggles, filters). */
  actions?: React.ReactNode;
}

/**
 * "rillo"-style page header: a large tight title with a muted subtitle line
 * (often carrying inline stats) and optional right-aligned actions.
 */
export default function PageHeader({ title, subtitle, actions }: PageHeaderProps) {
  return (
    <Box
      sx={{
        display: 'flex',
        alignItems: { xs: 'flex-start', sm: 'flex-end' },
        justifyContent: 'space-between',
        gap: 2,
        flexDirection: { xs: 'column', sm: 'row' },
        mb: 3,
      }}
    >
      <Box sx={{ minWidth: 0 }}>
        <Typography variant="h4" sx={{ fontWeight: 600, fontSize: { xs: 26, sm: 30 }, letterSpacing: '-0.02em' }}>
          {title}
        </Typography>
        {subtitle && (
          <Typography
            sx={{ color: 'text.secondary', mt: 0.5, fontSize: 14.5 }}
            className="tabular-nums"
          >
            {subtitle}
          </Typography>
        )}
      </Box>
      {actions && <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, flexShrink: 0 }}>{actions}</Box>}
    </Box>
  );
}
